import { motion } from 'framer-motion';
import { Play, Loader2, Zap, AlertCircle } from 'lucide-react';

export function RunBar({ canRun, running, onRun, error, runsPerDay, onRunsPerDayChange }) {
  return (
    <motion.div
      initial={{ opacity: 0, y: 12 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.55, delay: 0.3 }}
      className="sticky bottom-4 z-20 mt-4"
    >
      <div className="panel-strong flex flex-wrap items-center justify-between gap-4 p-4">
        <div className="flex items-center gap-3">
          <div className="flex items-center gap-2 rounded-xl border border-border-subtle bg-bg-deep/60 px-3 py-2">
            <Zap className="h-3.5 w-3.5 text-accent-cyan-light" />
            <span className="font-mono text-[10px] uppercase tracking-[0.14em] text-ink-dim">runs/day</span>
            <input
              type="number"
              min={1}
              max={10000}
              value={runsPerDay}
              onChange={(e) => onRunsPerDayChange(Math.max(1, Number(e.target.value) || 1))}
              className="w-16 bg-transparent text-center font-mono text-sm text-ink-primary outline-none"
            />
          </div>
          {error && (
            <div className="flex items-center gap-2 rounded-xl border border-signal-err/40 bg-signal-err/10 px-3 py-2 text-xs text-signal-err">
              <AlertCircle className="h-4 w-4" />
              <span className="font-mono">{error}</span>
            </div>
          )}
        </div>

        <motion.button
          whileHover={canRun && !running ? { scale: 1.02 } : {}}
          whileTap={canRun && !running ? { scale: 0.98 } : {}}
          disabled={!canRun || running}
          onClick={onRun}
          className="btn-primary px-6 py-3 text-base font-semibold"
        >
          {running ? (
            <>
              <Loader2 className="h-4 w-4 animate-spin" />
              Orchestrating…
            </>
          ) : (
            <>
              <Play className="h-4 w-4" fill="currentColor" />
              Run orchestration
            </>
          )}
        </motion.button>
      </div>
    </motion.div>
  );
}
